module.exports = __webpack_public_path__ + "static/fonts/MaterialIcons-Regular.a37b0c0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont/MaterialIcons-Regular.ttf
// module id = RXsc
// module chunks = 0